import BaseService from "../../services/BaseService";

class MCJOrgMemberDailyReportService extends BaseService {};

export default new MCJOrgMemberDailyReportService('health_backend', 'mcj_org_member_daily_reports');